var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"tp-1-txt align_heading"},[_vm._v("\n    Please choose a category for your property\n  ")]),_vm._v(" "),_c('router-view'),_vm._v(" "),_c('div',{staticClass:"row_grid_mob"},[_c('div',{staticClass:"grd-tp-bx-1 list-itm col-sm-12 col-md-12 col-xl-6 p-0"},_vm._l((_vm.thirdLevel),function(item,index){return _c('div',{key:index},[_c('router-link',{staticClass:"lnk-tp-lst-1 list-1",attrs:{"to":{
            path:'/dashboard/vendor/property',
            query:{
              purpose: _vm.$route.query.purpose,
              category: _vm.$route.query.category,
              category_id: _vm.$route.query.category_id,
              type: item.name
            }
          },"value":item.name}},[_c('div',{staticClass:"lnk-tp-lst-1-bx list-2"},[_c('span',{staticClass:"lnk-txt-1"},[_vm._v(_vm._s(item.name))])])])],1)}),0)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9041a838","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/profileDashboard/vendor/property/propertyType.vue
// module id = null
// module chunks = 